import { CourseModuleResponseDTO } from '@/jbi-shared/dto/jtms.dtos';
import {
  CreateCourseModuleResponse,
  CreateCourseModulesApiDTO,
  DeleteCourseModulesApiDTO,
  UpdateCourseModuleApiDTO
} from '@/store/modules/jtms/course-module/course-module.types';
import { axios } from './axios';

export const courseModuleApi = {
  createCourseModulesApi(payload: CreateCourseModulesApiDTO) {
    return axios.post<CreateCourseModuleResponse>(
      `/courses/${payload.courseId}/course-modules`,
      { courseModuleTempId: payload.courseModuleTempId }
    );
  },

  updateCourseModulesApi(payload: UpdateCourseModuleApiDTO) {
    return axios.patch<CourseModuleResponseDTO[]>(
      `/courses/${payload.courseId}/course-modules`,
      { courseModulesToUpdate: payload.courseModulesToUpdate }
    );
  },

  deleteCourseModulesApi(payload: DeleteCourseModulesApiDTO) {
    const { courseId, courseModuleIdsToDelete } = payload;
    return axios.delete(
      `/courses/${
        payload.courseId
      }/course-modules?ids=${courseModuleIdsToDelete.join(',')}`
    );
  }
};
